import axiosClient from "@/api/common/axiosClient.ts";

export const updateUser = (data: {
  name: string;
  phoneNumber: string;
  address1?: string;
  address2?: string;
  city?: string;
  county?: string;
  postcode?: string;
  dateOfBirth: string;
  signupAnswer?: string | null;
}) => {
  return axiosClient.put("users/me/", {
    name: data.name,
    phone_number: data.phoneNumber,
    address1: data.address1,
    address2: data.address2,
    city: data.city,
    county: data.county,
    postcode: data.postcode,
    date_of_birth: data.dateOfBirth,
    signup_answer: data.signupAnswer,
  });
};
